/*eslint-disable*/
import { useQuery } from '@tanstack/react-query';
import { RegularButton } from 'pg-ui-library';
import { useEffect, useState } from 'react';
import { DefaultTable } from 'src/components';
import SettingsService from 'src/services/settings.service';
import { PayrollConfigModal } from '../payroll-modal';

export const PayrollSummariesConfigTable = () => {
  const [payrollModal, setPayrollModal] = useState(false);
  const [companyId, setCompanyId] = useState('');

  const payrollConfigButton = (onClick: Function) => (
    <RegularButton onClick={() => onClick()}>Config Notification</RegularButton>
  );

  const setCompanyPayroll = (row: any) => {
    setCompanyId(row.legalEntityId);
    setPayrollModal(true);
  };

  const columns = [
    {
      name: 'ID',
      selector: (row: any) => row.legalEntityId,
      sortable: true,
      sortField: 'date',
      width: '120px',
    },
    {
      name: 'Company Name',
      selector: (row: any) => row.name,
      width: '70%',
    },
    {
      cell: (row: any) => payrollConfigButton(() => setCompanyPayroll(row)),
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        border: 'none',
      },
    },
    headCells: {
      style: {
        color: '#9399B2',
        font: 'normal normal bold 16px Biotif',
      },
    },
    rows: {
      style: {
        font: 'normal normal normal 14px Biotif',
        color: '#1B1D35',
        borderRadius: '5px',
        '&:not(:last-of-type)': {
          borderBottomWidth: '0px',
        },
      },
      stripedStyle: {
        color: '#1B1D35',
        backgroundColor: '#F3F4F8',
      },
      highlightOnHoverStyle: {
        backgroundColor: 'rgb(230, 244, 244)',
        borderBottomColor: '#FFFFFF',
        borderRadius: '25px',
        outline: '1px solid #FFFFFF',
      },
    },
    cells: {
      style: {
        justifyContent: 'left',
        '&:nth-of-type(5)': {
          justifyContent: 'right',
        },
      },
    },
    pagination: {
      style: {
        border: 'none',
      },
    },
  };
  const { isFetching, data, refetch } = useQuery(['payroll-summaries-config'], async () => {
    const result = SettingsService.getPayrollSettings();
    return result;
  });

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginRight: '2%',
          marginLeft: '2%',
          marginTop: '2%',
          marginBottom: '5%',
        }}
      >
        Payroll Notification Configuration.
        <hr style={{ flex: '1', margin: '0 0 0.5em 0.5em', border: 'none', borderTop: '1px solid #ccc' }} />
      </div>

      <PayrollConfigModal payrollModal={payrollModal} setPayrollModal={setPayrollModal} companyId={companyId} />
      <DefaultTable
        columns={columns}
        customStyles={customStyles}
        data={((data as any)?.items as unknown as []) || []}
        pagination={false}
      />
    </div>
  );
};
